module.exports = __webpack_public_path__ + "static/media/snowCamping_web.387bc338.jpg";